import "./turnstile.scss";

import stimulus from './stimulus';
import Turnstile from "./plugins/turnstile";

stimulus.register('turnstile', Turnstile);
